module.exports = __webpack_public_path__ + "static/media/11.89ba2fe4.jpeg";